<template>
  <div class="bannerSty" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="">
      <!-- data-stellar-ratio="0.2" style="transform: translate3d(0px,0px, 0px);" -->
      <div class="">
        <template>
          <div :class="pc ? 'bannerImg' : ''">
            <swiper-pic
              v-if="imgData.length >= 1"
              :imgData="imgData"
            ></swiper-pic>
          </div>
        </template>
      </div>
      <!-- 滚动下拉 -->
      <!-- <div
        v-if="pc && namedownsflag"
        class="goNext onlyD namedowns"
        @click="namedown"
      >
        {{ $t("homePage.namedown") }}<br /><i class="icon icon-arrow-down-2"
          >&nbsp;</i
        >
      </div> -->
      <!-- <div class="section_homeSlider"> -->
      <!-- data-stellar-ratio="0.3" -->
      <!-- <div class="title" style="transform: translate3d(0px, 0px, 0px);">
          <p class="title-text-2"><strong>{{ $t('homePage.name') }}</strong></p>
          <p class="title-text-3" v-html="$t('homePage.namet')">{{$t('homePage.namet')}}</p>
        </div> -->
      <!-- <div class="goNext onlyD" @click="namedown">{{$t('homePage.namedown')}}<br><i class="icon icon-arrow-down-2">&nbsp;</i></div>
      </div> -->
      <div class="section section_discover section_contact1" id="Distribution">
        <div class="inner">
          <!-- PC端========豪华汽车经销 -->
          <div
            class="discover-desktop desktopSty dealership"
            ref="Distribution"
          >
            <div class="clearFix firstCol" style="width: 68%; margin: 0 auto">
              <div
                class="rightContent"
                id="Distribution1"
                :style="locale == 'en' ? 'margin-top:0' : ''"
              >
                <div style="padding: 17px">
                  <h1
                    class="title heading1 heading-underline"
                    :style="locale == 'en' ? 'margin:10px 0 10px' : ''"
                  >
                    <span class="light">{{ $t("homePage.premium") }}</span>
                    <strong>{{ $t("homePage.title") }}</strong>
                  </h1>
                  <p :class="pc ? 'description descriptionpc' : 'description'">
                    {{ $t("homePage.description") }}
                  </p>
                  <div>
                    <img
                      src="../assets/homePage/home/padPright1.png"
                      alt="discover"
                    />
                  </div>
                </div>
              </div>
              <div class="leftContent" id="Distribution0">
                <img
                  src="../assets/homePage/home/padPleft.png"
                  alt="discover"
                  class="discoverImage"
                />
              </div>
            </div>
            <div class="secondCol">
              <div class="rightContent clearFix">
                <div id="Distribution3">
                  <img
                    src="../assets/homePage/home/padPcenter1.png"
                    alt="discover"
                    class="discoverImage1"
                  />
                </div>
                <div class="discoverDiv2" id="Distribution4">
                  <img
                    src="../assets/homePage/home/padPcenter2.png"
                    alt="discover"
                    class="discoverImage2"
                  />
                </div>
                <div class="discoverDiv3" id="Distribution5">
                  <img
                    src="../assets/homePage/home/padPcenter3.png"
                    alt="discover"
                    class="discoverImage3"
                  />
                </div>
              </div>
            </div>
            <div class="distribution_footer motitle">
              <p class="description" id="Distribution2">
                {{ $t("homePage.leftContent") }} <br />
                {{ $t("homePage.leftContentTwo") }}
              </p>
            </div>
          </div>
          <!-- 移动端========豪华汽车经销 -->
          <div class="mobileSty swiper-containerPad mobileSty">
            <div ref="mobiletitile">
              <h1 class="title heading1 discover_title" id="mocar">
                <span class="light">{{ $t("homePage.premium") }}</span>
                <strong>{{ $t("homePage.title") }}</strong>
              </h1>
            </div>

            <div class="mobileSty discoverMob" style="position: relative">
              <!-- <el-carousel
                ref="slideCarousel"
                indicator-position="outside"
                :autoplay="false"
                arrow="never"
                id="slideCarousel"
              >
                <el-carousel-item
                  v-for="(item, index) in companyImg1"
                  :key="index"
                >
                  <img :src="item" alt="discover" />
                </el-carousel-item>
              </el-carousel> -->
              <div class="swiper-container swiper-three" id="swiperthree">
                <div class="swiper-wrapper">
                  <div
                    class="swiper-slide"
                    v-for="(item, index) in companyImg1"
                    :key="index"
                  >
                    <img :src="item" alt="discover" />
                  </div>
                </div>
              </div>
              <div class="swiper-pagination1"></div>
            </div>
            <div class="distribution_footer cartitle">
              <p class="description" style="margin: 0">
                {{ $t("homePage.description") }}
              </p>
              <p class="description" style="margin: 0">
                {{ $t("homePage.leftContent") }} <br />
                {{ $t("homePage.leftContentTwo") }}
              </p>
            </div>
            <!-- 分页器 -->
            <!-- <div class="swiper-pagination"></div> -->
          </div>
        </div>
      </div>
      <!-- 企业信息 -->
      <div style="background-color: #fff; position: relative">
        <div class="commpany section_contact2">
          <div class="companyInner">
            <div class="title">
              <p class="heading1">
                <strong>{{ $t("homePage.Create") }}</strong>
              </p>
              <p class="heading1 roboto-light">
                {{ $t("homePage.limousine") }}
              </p>
            </div>
            <!-- pc -->
            <div
              class="futureList clearFix desktopSty"
              ref="Commpanytop"
              id="commpanyShow"
              style="visibility: hidden"
            >
              <div
                v-for="(item, indexs) in companyImg2"
                :key="indexs"
                class="futureSliderItem"
                :class="leaders(item.id)"
              >
                <div class="colInner">
                  <div class="futureItem">
                    <div class="itemBg">
                      <img :src="item.img" alt="future" class="img100 onlyTD" />

                      <div class="itemContentInner">
                        <div class="icon">
                          <img
                            :src="item.pcPicture"
                            alt="pic"
                            class="img100 onlyTD fsi_1"
                          />
                        </div>
                        <p class="heading2">
                          <strong>{{ item.enterpriseValue }}</strong>
                          <strong>{{ item.numericalUnit }}</strong>
                        </p>
                        <p>
                          <strong>{{ item.mainTitle }}</strong>
                        </p>
                        <p>
                          <strong>{{ item.subtitle }}</strong>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- mobile -->
            <div class="mobileSty messageMob" ref="slideRun">
              <div class="swiper-container swiper-four">
                <div class="swiper-wrapper">
                  <div
                    class="swiper-slide swiper-slide-active slideruns"
                    v-for="(item, index) in companyImg3"
                    :key="index"
                  >
                    <img :src="item.img" alt="discover" />
                    <div class="itemContent">
                      <div class="itemContentInner">
                        <div class="icon">
                          <img
                            :src="item.pcPicture"
                            alt="pic"
                            class="messageMb"
                          />
                          <p class="heading3">
                            <strong>{{ item.enterpriseValue }}</strong>
                            <strong>{{ item.numericalUnit }}</strong>
                          </p>
                          <p class="heading4">
                            <strong>{{ item.mainTitle }}</strong>
                          </p>
                          <p class="heading5">
                            <strong>{{ item.subtitle }}</strong>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="swiper-pagination2"></div>
            </div>

            <p style="text-align: center" class="endDates">
              {{ deadline }}
            </p>
          </div>
        </div>
      </div>

      <div style="width: 100%; background-color: #fff; position: relative">
        <div
          class="clearfix journal-content-article"
          data-analytics-asset-id="3268753"
          data-analytics-asset-title="品牌合作伙伴"
          data-analytics-asset-type="web-content"
        >
          <div class="desktopSty" style="position: relative" ref="tmTop">
            <img
              src="../assets/homePage/home/footerprint_back.png"
              alt=""
              class="triangleback"
            />
            <img
              src="../assets/homePage/home/footerprint_bgmask.png"
              alt=""
              class="trianglemask"
            />
            <!-- pc品牌合作 -->
            <div class="desktopSty section section_partners deskpartner">
              <div :class="pc ? 'inner section_contact3' : 'inner'">
                <p
                  class="
                    heading1
                    aCenter
                    heading-underline
                    upAnimation
                    friendCompany
                  "
                  :class="locale == 'zh' ? 'title' : 'titlee'"
                >
                  <strong>{{ $t("homePage.upAnimation") }}</strong>
                  <span class="light">{{ $t("homePage.upAnimationTwo") }}</span>
                  <strong>{{ $t("homePage.upAnimationThree") }}</strong>
                </p>
              </div>
              <p class="aCenter description upAnimation friendMessage">
                <span>{{ $t("homePage.centerUpAnimation") }}</span>
              </p>
              <!-- 品牌logo 7个 -->
              <div v-if="logoLength === 7" class="brandList">
                <!-- animated fadeInRight -->
                <div class="brandListInner clearFix">
                  <div
                    class="brandItem logoOne"
                    v-for="(item, index) in brandLogo.slice(0, 3)"
                    :key="index"
                    :id="'logoO' + index"
                    :style="{ animationDelay: index / 2 + 's' }"
                  >
                    <img :src="item.pcPicture" alt="partners" class="img" />
                  </div>
                </div>
                <!-- animated fadeInRight -->
                <div class="brandListInner clearFix">
                  <div
                    class="brandItem hidden"
                    v-for="(item, index) in brandLogo.slice(3, 7)"
                    :key="index"
                    :id="'logoO2' + index"
                    :style="{ animationDelay: index / 2 + 's' }"
                  >
                    <img :src="item.pcPicture" alt="partners" class="img" />
                  </div>
                </div>
              </div>
              <!-- 品牌logo 6个 -->
              <div v-if="logoLength === 6" class="brandList">
                <div class="brandListInner clearFix">
                  <!-- animated fadeInRight -->
                  <div
                    class="brandItem"
                    v-for="(item, index) in brandLogo"
                    :key="index"
                    :class="[brandItemSix]"
                    :id="'logoT' + index"
                    :style="{ animationDelay: index / 2 + 's' }"
                  >
                    <img :src="item.pcPicture" alt="partners" class="img" />
                  </div>
                </div>
              </div>
              <!-- 品牌logo 5个 -->
              <div class="brandList">
                <div class="brandListInner clearFix brandFive">
                  <!-- animated fadeInRight -->
                  <div
                    class="brandItem brandItemFive"
                    v-for="(item, index) in brandLogo"
                    :key="index"
                    :id="'logoTe' + index"
                    :style="{ animationDelay: index / 2 + 's' }"
                  >
                    <img :src="item.pcPicture" alt="partners" class="img" />
                  </div>
                </div>
              </div>
              <div
                class="aCenter"
                :class="locale == 'zh' ? 'buttonBoxs' : 'buttonBoxe'"
              >
                <a
                  @click="lookMore()"
                  href="/business/premium-auto-brands"
                  class="commonBtn btnStyle2 upAnimation"
                  style="z-index: 6"
                  ><span>{{ $t("homePage.lookMore") }}</span></a
                >
              </div>
            </div>
            <!-- pc 我们的足迹 -->
            <div class="innerPage footprint desktopSty">
              <div
                class="clearfix journal-content-article"
                data-analytics-asset-title="我们的足迹"
                data-analytics-asset-type="web-content"
              >
                <div :class="pc ? 'inner innerpc section_contact4' : 'inner'">
                  <!-- <img
                    class="imgbg"
                    src="../assets/homePage/home/footerprint_bg1.png"
                    alt=""
                  /> -->
                  <div style="visibility: hidden" id="footerShow">
                    <div class="colInner" ref="tmTop">
                      <h1
                        class="heading1 heading-underline left-under"
                        id="footertitles"
                      >
                        <strong style="font-size: 50px">{{
                          $t("homePage.ourFootprints")
                        }}</strong>
                      </h1>
                      <p id="footertexts">
                        <span>
                          <span>
                            <font>{{ $t("homePage.ourFootprintsCon") }}</font>
                          </span>
                        </span>
                      </p>
                      <p id="footerbtns">
                        <a class="commonBtn btnStyle2" href="/network" @click="lookAll()"
                          ><span>{{ $t("homePage.viewAll") }}</span></a
                        >
                      </p>
                    </div>
                  </div>
                  <!-- <div class="networkCol-2">
                    <div class="colInner" :style="pc?'':'padding-bottom: 40px;'">
                      <div class="map">
                        <img src="../assets/homePage/footprint/PMmap.png" alt="map" class="img100">
                      </div>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
          <!-- 移动端 品牌合作伙伴 -->
          <div class="mobileSty section section_partners section_contact3">
            <div class="inner">
              <p class="heading1 title aCenter heading-underline upAnimation">
                <strong>{{ $t("homePage.upAnimation") }}</strong>
                <span class="light">{{ $t("homePage.upAnimationTwo") }}</span>
                <strong>{{ $t("homePage.upAnimationThree") }}</strong>
              </p>

              <p class="aCenter description upAnimation">
                {{ $t("homePage.centerUpAnimation") }}
              </p>
              <!-- 品牌logo 7个 -->
              <div class="brandList">
                <!-- animated fadeInRight -->
                <div class="brandListInner clearFix">
                  <div
                    class="brandItem"
                    v-for="(item, indexs) in brandLogo"
                    :key="indexs"
                    :id="'logoOm' + indexs"
                    :style="{ animationDelay: indexs / 2 + 's' }"
                  >
                    <img :src="item.pcPicture" alt="partners" class="img" />
                  </div>
                </div>
              </div>
              <div class="aCenter buttonBox">
                <a
                  
                  href="/business/premium-auto-brands"
                  class="commonBtn btnStyle2 upAnimation"
                  ><span>{{ $t("homePage.lookMore") }}</span></a
                >
              </div>
              <!-- <div class="gray-line"></div> -->
            </div>
            <div class="mask"></div>
          </div>
          <!-- mobile 我们的足迹 -->
          <div class="innerPage mobileSty section_contact4">
            <div
              class="clearfix journal-content-article"
              data-analytics-asset-title="我们的足迹"
              data-analytics-asset-type="web-content"
            >
              <div class="section section_network section_networkm">
                <div class="'inner">
                  <div class="colRow clearFix">
                    <div>
                      <div class="colInner">
                        <h1
                          class="heading1 heading-underline left-under location"
                        >
                          <strong>{{ $t("homePage.ourFootprints") }}</strong>
                        </h1>

                        <p class="track">
                          <span>
                            <span>
                              <font>{{ $t("homePage.ourFootprintsCon") }}</font>
                            </span>
                          </span>
                        </p>
                        <!-- m端我们的足迹透明蒙版 -->
                        <!-- <img
                          src="../assets/homePage/home/751.png"
                          alt="map"
                          class="footmbmask"
                        /> -->
                        <img
                          src="../assets/homePage/home/750.png"
                          alt="map"
                          class="footmbimg"
                        />
                        <div class="footermbimg">
                          <p class="footermbbtn">
                            <a
                              @click="lookAll()"
                              class="commonBtn btnStyle2"
                              href="/network"
                              ><span>{{ $t("homePage.viewAll") }}</span></a
                            >
                          </p>
                        </div>
                      </div>
                    </div>
                    <!-- <div class="networkCol-2">
                    <div class="colInner" :style="pc?'':'padding-bottom: 40px;'">
                      <div class="map">
                        <img src="../assets/homePage/home/670x290-BG-5.png" alt="map" class="img100">
                      </div>
                    </div>
                  </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="section section_services desktopSty" ref="secondhandTop">
            <div class="inner">
              <div class="clearFix serviceList" id="servicePc">
                <div
                  v-for="(item, index) in businessList"
                  :key="index"
                  class="serviceInner hidden-md"
                  :id="'carProducts' + index"
                >
                  <div>
                    <a
                      class="serviceItem service1"
                      @click="goLinkUrl(item.linkUrl)"
                    >
                      <div
                        class="bgImg onlyTD"
                        :style="{
                          backgroundImage: 'url(' + item.pcPicture + ')',
                        }"
                      ></div>
                      <div
                        class="bgImg onlyM"
                        :style="{
                          backgroundImage: 'url(' + item.mbPicture + ')',
                        }"
                      ></div>
                      <div class="serviceText">
                        {{ item.mainTitle }}
                        <i class="icon icon-arrowStrokeRight"></i>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="section section_services mobileSty" id="sectionMb">
            <div class="swiper-containerMobile inner">
              <div
                class="swiper-wrapper clearFix serviceList"
                @click="goLinkUrlm()"
              >
                <div
                  class="
                    swiper-slide
                    serviceInner
                    hidden-md
                    big
                    animated
                    fadeInLeftSmall
                  "
                  v-for="(item, index) in businessList"
                  :key="index"
                >
                  <div class="toUrl">
                    <div class="serviceItem service1">
                      <div
                        class="bgImg onlyM"
                        :style="{
                          backgroundImage: 'url(' + item.mbPicture + ')',
                        }"
                      ></div>
                    </div>
                    <div class="serviceTextM onlyM">
                      {{ item.mainTitle }}
                      <i class="icon icon-arrowStrokeRight"></i>
                    </div>
                  </div>
                </div>
              </div>

              <div class="swiper-paginationBus businessStyle"></div>
            </div>
          </div>
          <!-- 新闻pc -->
          <div
            v-if="showNews"
            class="section section_news_homepage section_news_v2"
          >
            <input type="hidden" id="languagesType" value="zh" />
            <div class="newsInner" style="">
              <div class="newsinner_width">
                <div class="inner">
                <div class="titleBox" v-if="pc">
                  <h1
                    class="
                      heading-underline
                      left-under
                      hidden
                      animated
                      fadeInUpSmall
                      newTitle
                    "
                  >
                    {{ $t("homePage.news") }}
                    <a
                    to="/news"
                    @click="getNewsAll"
                    class="link hidden animated fadeInRight"
                    style="z-index: 79; cursor: pointer"
                    >{{ $t("homePage.viewAll") }}
                    <i class="icon icon-arrowStrokeRight">&nbsp;</i></a
                  >
                  </h1>
                  
                </div>
                <div class="titleBox" v-if="mobile">
                  <h1 class="heading-underline left-under hidden" id="a1">
                    {{ $t("homePage.news") }}
                  </h1>
                  <a href="/news" class="link hidden" id="a2"
                    >{{ $t("homePage.viewAll") }}
                    <i class="icon icon-arrowStrokeRight">&nbsp;</i></a
                  >
                </div>
              </div>
              <div class="newsListInner">
                <div class="inner">
                  <div class="clearFix newsList" ref="newsTop">
                    <div
                      class="newsItemInner hidden"
                      v-for="(item, index) in queryNewsList"
                      :key="index"
                      :id="'news' + index"
                    >
                      <div>
                        <div
                          class="newsItem"
                          @mouseenter="on_bot_enter(index)"
                          @mouseleave="on_bot_leave(index)"
                        >
                          <div
                            class="bg"
                            :style="{
                              backgroundImage:
                                'url(' + item.pcNewsCoverPicture + ')',
                            }"
                          ></div>
                          <div class="news">
                            <div class="newsTitle">
                              {{ item.newsHeadlines }}
                            </div>
                            <div class="description">
                              <span>{{ item.newsSummary }}</span>
                            </div>
                            <div
                              class="link commonBtn btnStyle3"
                              @click="getNewDetail(item.newsId)"
                            >
                              <span
                                >{{ $t("homePage.queryMore") }}
                                <i class="icon icon-arrowStrokeRight"></i
                              ></span>
                            </div>
                          </div>
                          <img
                            src="../assets/homePage/home/maskLeft.png"
                            :class="
                              hoverIndex === index && mouseFlag
                                ? 'newsMaskLeft animated fadeInLeftDown'
                                : 'newsMaskLeft'
                            "
                          />
                          <img
                            src="../assets/homePage/home/maskRight.png"
                            :class="
                              hoverIndex === index && mouseFlag
                                ? 'newsMaskRight animated fadeInRightUp'
                                : 'newsMaskRight'
                            "
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="newsListM">
                    <a
                      @click="getNewDetail(item.newsId)"
                      class="newsItemM clearFix"
                      v-for="(item, index) in queryNewsList"
                      :key="index"
                    >
                      <img
                        :style="{
                          backgroundImage:
                            'url(' + item.pcNewsCoverPicture + ')',
                          backgroundRepeat: 'no-repeat',
                          backgroundPosition: '50%',
                          backgroundSize: 'cover',
                        }"
                      />
                      <div class="title">{{ item.newsSummary }}</div>
                    </a>
                  </div>
                </div>
              </div>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getlogo,
  brandIntro,
  queryKv,
  enterpriseInfo,
  businessIntro,
  queryRecNews,
} from "../api/news";
import SwiperPic from "../components/SwiperPic.vue";
import Swiper from "swiper";
import { mapState } from "vuex";
import p1 from "../assets/homePage/home/padPleft.png";
import p2 from "../assets/homePage/home/padPright.png";
import p3 from "../assets/homePage/home/padPcenter1.png";
import p4 from "../assets/homePage/home/padPcenter2.png";
import p5 from "../assets/homePage/home/padPcenter3.png";
import b1 from "../assets/homePage/home/company1.jpg";
import b2 from "../assets/homePage/home/company2.jpg";
import b3 from "../assets/homePage/home/company3.jpg";
import b4 from "../assets/homePage/home/company4.jpg";
import b5 from "../assets/homePage/home/company5.jpg";
import c1 from "../assets/homePage/home/670x290-BG-1.png";
import c2 from "../assets/homePage/home/670x290-BG-2.png";
import c3 from "../assets/homePage/home/670x290-BG-3.png";
import c4 from "../assets/homePage/home/670x290-BG-4.png";
import c5 from "../assets/homePage/home/670x290-BG-5.png";
export default {
  name: "HomePage",
  data() {
    return {
      logoLength: "",
      brandItemSix: "brandItemSix",
      brandItemFive: "brandItemFive",
      brandItemOther: "brandItemOther",
      swiperflageindex: 0,
      locale: "",
      newSwiper: "",
      // imgData: [
      //   { id: 1, url: 'homePage-Pbanner1.jpg' },
      //   { id: 2, url: 'homePage-Pbanner2.jpg' },
      //   { id: 3, url: 'homePage-Pbanner3.jpg' }
      // ],
      mouseFlag: false,
      hoverIndex: 0,
      imgData: [],
      corpInfoRespList: [],
      deadline: "",
      brandLogo: [],
      mainTitle: "",
      businessList: [], // 业务介绍数据
      queryNewsList: [], // 推荐新闻数据
      mouseFlag1: false,
      mouseFlag2: false,
      mouseFlag3: false,
      datas: false, // 动态数据
      tm: false, // 品牌合作伙伴
      secondhand: false, // 二手车
      news: false, // 新闻
      fullscreenLoading: false,
      newSwiperMobile: null,
      showNews: false,
      namedownsflag: true,
      urlNumber: 0,
      bool1: true,
      bool2: true,
      bool3: true,
      bool4: true,
      companyImg1: [p1, p2, p3, p4, p5],
      companyImg2: [
        { img: b1, id: "1" },
        { img: b2, id: "2" },
        { img: b3, id: "3" },
        { img: b4, id: "4" },
        { img: b5, id: "5" },
      ],
      companyImg3: [
        { img: c1, id: "1" },
        { img: c2, id: "2" },
        { img: c3, id: "3" },
        { img: c4, id: "4" },
        { img: c5, id: "5" },
      ],
      // testShow: false,
      // testShow1: false,
      swiper: null,
      isSystem: "",
    };
  },
  components: {
    SwiperPic,
  },
  created() {
    this.locale = localStorage.languageSet;
  },
  computed: mapState(["locali18n"]),
  watch: {
    locali18n() {
      this.locale = this.locali18n;
      console.log("locali18n", this.locale);
    },
  },
  mounted() {
    this.fetch();
    this.swiperPad();
    this.swiperMobile();
    window.addEventListener("scroll", this.moveFun, true);
    this.slideBanner1();
    this.slideBanner2();
    sessionStorage.removeItem('detailid')
    this.$nextTick(function () {
      // 滚动监听事件
      window.addEventListener("scroll", this.menufun1);
      window.addEventListener("scroll", this.menufun2);
      window.addEventListener("scroll", this.menufun3);
      window.addEventListener("scroll", this.menufun4);
    });
  },
  methods: {
    // GA 豪华汽车
    menufun1() {
      const _self = this;
      _self.scroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (
        _self.scroll > $(".section_contact1").offset().top - 150 &&
        this.bool1
      ) {
        this.bool1 = false;
        this.$gtag("event", "impression", {
          site: localStorage.languageSet,
          page_group: this.$route.meta.pageGroup,
          event_category: "PREMIUM AUTOMOTIVE RETAILING",
          send_to: "G-9LRNGL9NJ8",
        });
      }
    },
    menufun2() {
      const _self = this;
      _self.scroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (
        _self.scroll > $(".section_contact2").offset().top - 150 &&
        this.bool2
      ) {
        this.bool2 = false;
        this.$gtag("event", "impression", {
          site: localStorage.languageSet,
          page_group: this.$route.meta.pageGroup,
          event_category: "DRIVING",
          send_to: "G-9LRNGL9NJ8",
        });
      }
    },
    menufun3() {
      const _self = this;
      _self.scroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (
        _self.scroll > $(".section_contact3").offset().top - 150 &&
        this.bool3
      ) {
        this.bool3 = false;
        this.$gtag("event", "impression", {
          site: localStorage.languageSet,
          page_group: this.$route.meta.pageGroup,
          event_category: "BRANDS PARTNERS",
          send_to: "G-9LRNGL9NJ8",
        });
      }
    },
    menufun4() {
      const _self = this;
      _self.scroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (
        _self.scroll > $(".section_contact4").offset().top - 150 &&
        this.bool4
      ) {
        this.bool4 = false;
        this.$gtag("event", "impression", {
          site: localStorage.languageSet,
          page_group: this.$route.meta.pageGroup,
          event_category: "OUR FOOTPRINT",
          send_to: "G-9LRNGL9NJ8",
        });
      }
    },
    lookMore() {
      this.$gtag("event", "click", {
        site: localStorage.languageSet,
        page_group: this.$route.meta.pageGroup,
        event_category: "read more",
        event_label: "read more",
        send_to: "G-9LRNGL9NJ8",
      });
    },
    lookAll() {
      this.$gtag("event", "click", {
        site: localStorage.languageSet,
        page_group: this.$route.meta.pageGroup,
        event_category: "read all",
        event_label: "read all",
        send_to: "G-9LRNGL9NJ8",
      });
    },
    // 鼠标滚动事件
    moveFun() {
      // const _self = this;
      // _self.scroll =
      // document.documentElement.scrollTop || document.body.scrollTop;
      // var currentScroll = window.pageYOffset; //表示当前滚动的位置
      // 引领
      // console.log(_self.scroll);
      // if (_self.scroll >= 3400) {
      //   this.testShow = true;
      // }
    },
    // 点击滚动
    // namedown() {
    //   // var scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    //   // var cHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
    //   var oDiv = document.getElementById("Distribution");
    //   // console.log(scrollTop, (oDiv.offsetTop - cHeight), oDiv.offsetTop, cHeight)
    //   const timer = setInterval(function () {
    //     this.namedownsflag = false;
    //     document.documentElement.scrollTop =
    //       document.documentElement.scrollTop + oDiv.offsetTop / 50;
    //     if (document.documentElement.scrollTop > oDiv.offsetTop - 20) {
    //       clearInterval(timer);
    //     }
    //   }, 10);
    // },
    getNewDetail(newId) {
      sessionStorage.setItem("detailid", JSON.stringify(newId));
      this.$router.push({
        path: "/newsDetail",
        query: {
          id: newId,
        },
      });
    },
    getNewsAll() {
      this.$router.push({
        path: "/news",
      });
    },
    goLinkUrlm() {
      window.open(this.businessList[this.urlNumber].linkUrl, "_self");
    },
    goLinkUrl(linkUrl) {
      console.log("linkUrl", linkUrl);
      // this.$router.push({
      //   path: linkUrl
      // })
      window.open(linkUrl, "_self");
    },
    async fetch() {
      const params = {
        languageType: this.locale,
      };
      this.fullscreenLoading = true;
      // 品牌logo接口
      await getlogo().then((res) => {
        if (res.data) {
          this.brandLogo = res.data;
          this.logoLength = res.data.length;
          // console.log("123", this.brandLogo);
        }
      });
      // 轮播图接口
      await queryKv(params).then((res) => {
        if (res.data) {
          this.imgData = res.data;
          this.imgData.map((e) => {
            e.type = e.pcPicture.substring(e.pcPicture.length - 3);
            e.types = e.mbPicture.substring(e.mbPicture.length - 3);
          });
        }
      });
      // 品牌介绍接口

      await brandIntro(params).then((res) => {
        if (res.data) {
          this.mainTitle = res.data.mainTitle;
        }
      });
      // 企业信息接口
      await enterpriseInfo(params).then((res) => {
        if (res.data) {
          this.corpInfoRespList = res.data.corpInfoRespList;
          this.deadline = res.data.deadline;
          this.companyImg3.map((e, index) => {
            e.pcPicture = this.corpInfoRespList[index].pcPicture;
            e.mbPicture = this.corpInfoRespList[index].mbPicture;
            e.enterpriseValue = this.corpInfoRespList[index].enterpriseValue;
            e.numericalUnit = this.corpInfoRespList[index].numericalUnit;
            e.mainTitle = this.corpInfoRespList[index].mainTitle;
            e.subtitle = this.corpInfoRespList[index].subtitle;
            e.linkUrl = this.corpInfoRespList[index].linkUrl;
          });
          this.companyImg2.map((e, index) => {
            e.pcPicture = this.corpInfoRespList[index].pcPicture;
            e.mbPicture = this.corpInfoRespList[index].mbPicture;
            e.enterpriseValue = this.corpInfoRespList[index].enterpriseValue;
            e.numericalUnit = this.corpInfoRespList[index].numericalUnit;
            e.mainTitle = this.corpInfoRespList[index].mainTitle;
            e.subtitle = this.corpInfoRespList[index].subtitle;
            e.linkUrl = this.corpInfoRespList[index].linkUrl;
          });
        }
      });
      // 业务介绍入口
      await businessIntro(params).then((res) => {
        if (res.data) {
          this.businessList = res.data;
          this.$nextTick(() => {
            var serviceLong = document.getElementById("servicePc");
            var serviceHeight =
              document.getElementsByClassName("section_services")[0];
            var servicembHeight = document.getElementById("sectionMb");
            if (serviceLong.offsetHeight < 120) {
              serviceHeight.style.padding = 0;
            }
            if (servicembHeight.offsetHeight < 120) {
              servicembHeight.style.padding = 0;
              servicembHeight.style.marginTop = 0;
              servicembHeight.style.marginBottom = 0;
            }
          });

          setTimeout(() => {
            this.newSwiperMobile.reLoop();
            this.newSwiperMobile.update();
          }, 100);
        }
      });
      // 推荐新闻接口
      await queryRecNews(params).then((res) => {
        if (res.status === 200) {
          this.queryNewsList = res.data;
          this.showNews = true;
        } else {
          this.showNews = false;
        }
      });
      this.fullscreenLoading = false;
      if (this.pc) {
        this.$nextTick(function () {
          // 滚动监听事件
          window.addEventListener("scroll", this.menu);
        });
        window.resetLayout();
      }
      if (this.mobile) {
        this.$nextTick(function () {
          // 滚动监听事件
          window.addEventListener("scroll", this.menumb);
        });
      }
    },
    leaders(index) {
      return "subject_sign" + index;
    },
    menumb() {
      const _self = this;
      _self.scroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      // console.log('menuTop', _self.scroll)
      if (this.$refs.mobiletitile.offsetTop - _self.scroll < 0) {
        $("#mocar").addClass("fadeInDownDistribution animated3");
      }
      if (_self.scroll - this.$refs.slideRun.offsetTop > 1200) {
        $(".slideruns").addClass("fadeInUpDistribution animated1");
      }
      if (_self.scroll > 220) {
        if (!this.datas) {
          window.inView(".section_count").on("enter", function (e) {
            // count number
            if (!$(".countAnimation").hasClass("counted")) {
              $(".countAnimation").each(function () {
                const $this = $(this);
                const isInt = $this.text() % 1 === 0;
                jQuery({ Counter: 0 }).animate(
                  { Counter: $this.text() },
                  {
                    duration: 1500,
                    easing: "swing",
                    step: function () {
                      if (isInt) {
                        $this.text(Math.ceil(this.Counter));
                      } else {
                        $this.text(this.Counter.toFixed(1));
                      }
                      $this.addClass("counted");
                    },
                  }
                );
              });
            }
          });
        }
        this.datas = true;
      }
      // 我们的伙伴
      // if (this.$refs.tmTop.offsetTop - _self.scroll < 640) {
      //   // alert('123')
      //   // console.log('123')
      //   for (var i = 0; i < this.brandLogo.length; i++) {
      //     $("#logoOm" + i).addClass("animated1 fadeInRight");
      //   }
      //   // $('#logoO0').addClass('animated fadeInRight')
      // }
      // if (_self.scroll > 1250) {
      //   $("#a1").addClass("animated1 fadeInUpSmall");
      //   $("#a2").addClass("animated1 fadeInRight");
      // }
    },
    menu() {
      const screenW = window.innerWidth;
      const _self = this;
      _self.scroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      // console.log(this.$refs.mobiletitile.offsetTop - _self.scroll);
      if (_self.scroll === 0) {
        this.namedownsflag = true;
      }
      if (_self.scroll > 10) {
        this.namedownsflag = false;
      }

      if (_self.scroll - this.$refs.Distribution.offsetTop > 100) {
        $("#Distribution0").addClass("animated fadeInUpDistribution");
        $("#Distribution1").addClass("animated fadeInDownDistribution");
        // $("#Distribution2").addClass("animated fadeInLeft");
        $("#Distribution3").addClass("animated2 fadeInUpDistribution6");
        $("#Distribution4").addClass("animated25 fadeInUpDistribution7");
        $("#Distribution5").addClass("animated3 fadeInUpDistribution8");
      }
      if (_self.scroll - this.$refs.Commpanytop.offsetTop > 1000) {
        document.getElementById("commpanyShow").style.visibility = "visible";
        $(".subject_sign1").addClass("animated1 fadeInDownDistribution");
        $(".subject_sign2").addClass("animated2 fadeInUpDistribution");
        $(".subject_sign3").addClass("animated3 fadeInDownDistribution");
        $(".subject_sign4").addClass("animated4 fadeInUpDistribution");
        $(".subject_sign5").addClass("animated5 fadeInDownDistribution");
      }
      // if (_self.scroll - this.$refs.Footertop.offsetTop > 2600) {
      //   document.getElementById("footerShow").style.visibility = "visible";
      //   $("#footerbtns").addClass("footerbtn");
      //   $("#footertexts").addClass("footertext");
      //   $("#footertitles").addClass("footertitle");
      //   // $(".footerimgs").addClass("footerimg");
      // }
      // if ((this.$refs.datas.offsetTop - _self.scroll) < 900) {
      // if (!this.datas) {
      //   window.inView(".section_count").on("enter", function (e) {
      //     // count number
      //     if (!$(".countAnimation").hasClass("counted")) {
      //       $(".countAnimation").each(function () {
      //         const $this = $(this);
      //         const isInt = $this.text() % 1 === 0;
      //         jQuery({ Counter: 0 }).animate(
      //           { Counter: $this.text() },
      //           {
      //             duration: 1500,
      //             easing: "swing",
      //             step: function () {
      //               if (isInt) {
      //                 $this.text(Math.ceil(this.Counter));
      //               } else {
      //                 $this.text(this.Counter.toFixed(1));
      //               }
      //               $this.addClass("counted");
      //             },
      //           }
      //         );
      //       });
      //     }
      //   });
      // }
      // this.datas = true;
      // }
      // console.log( _self.scroll-this.$refs.tmTop.offsetTop,"6666666666")
      // if (
      //   screenW > 1400
      //     ? this.$refs.tmTop.offsetTop - _self.scroll < -2300
      //     : this.$refs.tmTop.offsetTop - _self.scroll < 300
      // )
      if (_self.scroll - this.$refs.tmTop.offsetTop > 2100) {
        // $("#maskarrow1").addClass("animated1 fadeInLeft");
        // $("#maskarrow2").addClass("animated1 fadeInLeft");
        // $("#maskarrow3").addClass("animated1 fadeInRight");
        // $("#maskarrow4").addClass("animated1 fadeInRight");
        // document.getElementById("imgShow").style.display = "block";
        $(".trianglemask").addClass("footerimg");
        document.getElementById("footerShow").style.visibility = "visible";
        $("#footerbtns").addClass("footerbtn");
        $("#footertexts").addClass("footertext");
        $("#footertitles").addClass("footertitle");
      }
      // console.log(this.$refs.tmTop.offsetTop, '666666')
      // console.log(this.$refs.tmTop.offsetTop - _self.scroll, '777777')
      //   if (_self.scroll -this.$refs.tmTop.offsetTop> 2100){
      //   if (this.logoLength === 7) {
      //     for (let i = 0; i < 4; i++) {
      //       $("#logoO" + i).addClass("animated1 fadeInRight");
      //     }
      //     for (var j = 0; j < 7; j++) {
      //       $("#logoO2" + j).addClass("animated1 fadeInRight");
      //     }
      //   }
      //   if (this.logoLength === 6) {
      //     for (let i = 0; i < this.brandLogo.length; i++) {
      //       $("#logoT" + i).addClass("animated1 fadeInRight");
      //     }
      //   }
      //   if (this.logoLength < 6) {
      //     for (let i = 0; i < this.brandLogo.length; i++) {
      //       $("#logoTe" + i).addClass("animated1 fadeInRight");
      //     }
      //   }
      //   if (this.logoLength === 8) {
      //     for (let i = 0; i < this.brandLogo.length; i++) {
      //       $("#logoTe" + i).addClass("animated1 fadeInRight");
      //     }
      //   }
      // }
      // 业务介绍
      if (this.$refs.secondhandTop.offsetTop - _self.scroll < 650) {
        $("#carProducts0").addClass("big animated fadeInLeftSmall");
        $("#carProducts1").addClass("animated fadeInLeftDownSmall");
        $("#carProducts2").addClass("animated fadeInRightDownSmall");
        $("#carProducts3").addClass("animated fadeInLeftUpSmall");
        $("#carProducts4").addClass("animated fadeInRightUpSmall");
      }
      if (screenW > 1400) {
        if (this.$refs.newsTop.offsetTop - _self.scroll < -2680) {
          $("#news1").addClass("animated fadeInDowns");
          $("#news2").addClass("animated fadeIn");
          $("#news3").addClass("animated fadeInUp");
        }
      }
      // 新闻
      if (screenW < 1400) {
        if (this.$refs.newsTop.offsetTop - _self.scroll < -2880) {
          $("#news1").addClass("animated fadeInDowns");
          $("#news2").addClass("animated fadeIn");
          $("#news3").addClass("animated fadeInUp");
        }
      }
    },
    swiperPad() {
      const newSwiperPad = new Swiper(".swiper-containerPad", {
        loop: true,
        spaceBetween: 5,
        // 分页器
        pagination: ".swiper-pagination",
      });
    },
    swiperMobile() {
      var self = this;
      this.newSwiperMobile = new Swiper(".swiper-containerMobile", {
        spaceBetween: 0,
        pagination: ".swiper-paginationBus",
        loop: true,
        initialSlide: 1,
        observer: true, // swiper自己或子元素时，自动初始化swiper
        observeParents: true, // swiper的父元素时，自动初始化swiper
        onSlideChangeStart: function (swiper) {
          var lengths = self.businessList.length;
          if (swiper.activeIndex == 1 || swiper.activeIndex == lengths + 1) {
            self.urlNumber = 0;
          } else if (swiper.activeIndex == 0 || swiper.activeIndex == lengths) {
            self.urlNumber = lengths - 1;
          } else {
            self.urlNumber = swiper.activeIndex - 1;
          }
        },
      });
    },
    // 新闻鼠标事件 移入 class在vender.css
    on_bot_enter(index) {
      this.hoverIndex = index;
      this.mouseFlag = true;
    },
    // 移出
    on_bot_leave(index) {
      this.hoverIndex = index;
      this.mouseFlag = false;
    },
    slideBanner1() {
      const newSwiper = new Swiper(".swiper-three", {
        loop: true, // 如果需要分页器
        pagination: ".swiper-pagination1",
        nextButton: ".slick-next",
        prevButton: ".slick-prev",
        autoplay: 0, // 自动切换
        autoplayDisableOnInteraction: false,
        speed: 200,
        spaceBetween: 25,
        effect: "slide",
        observer: true, // swiper自己或子元素时，自动初始化swiper
        observeParents: true, // swiper的父元素时，自动初始化swiper
        onSlideChangeStart: function (swiper) {
          var s = document.getElementById("swiperthree");
          if (swiper.activeIndex == 1 || swiper.activeIndex == 6) {
            s.style.height = "491px";
            $("#swiperthree").addClass("pichiddens");
            $("#swiperthree").removeClass("pichidden");
            document.getElementsByClassName(
              "swiper-pagination1"
            )[0].style.bottom = "-30px";
            document.getElementsByClassName("cartitle")[0].style.margin =
              "24px 0 0 0";
          } else {
            s.style.height = "250px";
            $("#swiperthree").addClass("pichidden");
            $("#swiperthree").removeClass("pichiddens");
            document.getElementsByClassName(
              "swiper-pagination1"
            )[0].style.bottom = "35px";
            document.getElementsByClassName("cartitle")[0].style.margin =
              "-40px 0 0 0";
          }
        },
      });
      $(".swiper-pagination1").on("click", "span", function () {
        var index = $(this).index() + 1;
        newSwiper.slideTo(index);
        var s = document.getElementById("swiperthree");
        if (index == 1) {
          s.style.height = "491px";
          $("#swiperthree").addClass("pichiddens");
          $("#swiperthree").removeClass("pichidden");
          document.getElementsByClassName(
            "swiper-pagination1"
          )[0].style.bottom = "-30px";
          document.getElementsByClassName("cartitle")[0].style.margin =
            "24px 0 0 0";
        } else {
          s.style.height = "250px";
          $("#swiperthree").addClass("pichidden");
          $("#swiperthree").removeClass("pichiddens");
          document.getElementsByClassName(
            "swiper-pagination1"
          )[0].style.bottom = "35px";
          document.getElementsByClassName("cartitle")[0].style.margin =
            "-40px 0 0 0";
        }
      }),
        // this.swiperIndex = newSwiper.activeIndex
        console.log("newSwiper", newSwiper);
    },
    slideBanner2() {
      var that = this;
      var o = 0;
      const newSwiper = new Swiper(".swiper-four", {
        loop: true, // 如果需要分页器
        // loopAdditionalSlides: 1,
        pagination: ".swiper-pagination2",
        nextButton: ".slick-next",
        prevButton: ".slick-prev",
        // autoplay: 10000000, // 自动切换
        autoplayDisableOnInteraction: false,
        // speed: 300,
        spaceBetween: 25,
        effect: "slide",
        // initialSlide:0,
        observer: true, // swiper自己或子元素时，自动初始化swiper
        observeParents: true, // swiper的父元素时，自动初始化swiper
        onSlideChangeStart: function (swiper) {
          var card = document
            .getElementsByClassName("slideruns")
            [swiper.activeIndex].getElementsByClassName("itemContent")[0];
          var icon = card
            .getElementsByClassName("itemContentInner")[0]
            .getElementsByClassName("icon")[0];
          var img = icon.getElementsByClassName("messageMb")[0];
          var text1 = icon
            .getElementsByClassName("heading3")[0]
            .getElementsByTagName("strong")[0];
          var text2 = icon
            .getElementsByClassName("heading4")[0]
            .getElementsByTagName("strong")[0];
          var text3 = icon
            .getElementsByClassName("heading5")[0]
            .getElementsByTagName("strong")[0];
          if (swiper.activeIndex == 6) {
            img.src = that.companyImg3[0].pcPicture;
            text1.innerHTML =
              that.companyImg3[0].enterpriseValue +
              that.companyImg3[0].numericalUnit;
            text2.innerHTML = that.companyImg3[0].mainTitle;
            text3.innerHTML = that.companyImg3[0].subtitle;
          }
          if (swiper.activeIndex == 0) {
            img.src = that.companyImg3[4].pcPicture;
            text1.innerHTML =
              that.companyImg3[4].enterpriseValue +
              that.companyImg3[4].numericalUnit;
            text2.innerHTML = that.companyImg3[4].mainTitle;
            text3.innerHTML = that.companyImg3[4].subtitle;
          }
        },
      });
      $(".swiper-pagination2").on("click", "span", function () {
        var index = $(this).index() + 1;
        newSwiper.slideTo(index);
      });
      console.log("newSwiper", newSwiper);
    },
  },
};
</script>
<style>
.el-carousel__indicator--horizontal .el-carousel__button {
  width: 10px;
  height: 10px;
  background: transparent;
  border: 1px solid #ffffff;
  background: #cbcbcb;
  border-radius: 50%;
  opacity: 0.5;
}
.el-carousel__indicator--horizontal.is-active .el-carousel__button {
  width: 10px;
  height: 10px;
  background: #2f9eef;
  border-radius: 50%;
  opacity: 1;
}
el-carousel-item {
  position: relative;
  height: 200px;
  /* width:100%; */
}
.endDates {
  font-size: 15px;
  padding-top: 20px;
  margin-bottom: 0px;
}
.triangleback {
  width: 100%;
  height: auto;
}
.trianglemask {
  width: 100%;
  height: auto;
  position: absolute;
  top: 0;
  right: 0;
  opacity: 0;
  /* animation: footan 2s forwards;
   -webkit-animation: footan 2s forwards; */
  /* height: 100%;
  background: url("../assets/homePage/home/footerprint_bgmask.png");
  background-size: 100% auto !important;
  background-repeat: no-repeat!important ;
  background-position: left top !important; */
}
.commpany {
  width: 100%;
  padding: 50px 0 30px;
  background: url("../assets/homePage/home/messagebg.jpg");
  background-size: 100% 100% !important;
  background-repeat: no-repeat !important;
  background-position: left top !important;
}
.companyInner {
  position: relative;
  /* max-width: 1240px; */
  /* padding: 20px; */
  box-sizing: border-box;
  margin: 0px 30px;
}
.companyInner .title {
  margin: 50px 0;
  text-align: center;
}
.companyInner .title .heading1 {
  font-size: 48px;
  letter-spacing: normal;
}
.companyInner .title .roboto-light {
  font-size: 23px;
}
.clearFix {
  zoom: 1;
}
.friendCompany {
  text-align: left;
  /* max-width: 800px !important; */
  /* margin: 0 auto !important; */
  /* padding-left: 20px; */
}
.friendMessage {
  /* max-width: 800px !important; */
  margin: 0 !important;
  text-align: left;
  /* padding-left: 20px; */
}
.friendMessage span {
  display: inline-block;
  width: 600px;
}
.friendCompany.heading-underline:after {
  margin-left: 0px !important;
}
.desktopSty .brandList {
  width: 65%;
  margin-left: 0px;
}
.desktopSty .brandList .brandListInner {
  /* margin-left: 0 !important;
  padding-left: 30px; */
  display: flex;
  justify-content: left;
}
.deskpartner {
  position: absolute;
  left: 0;
  top: 0;
  height: 48%;
  padding-left: 106px;
}
.buttonBoxs,
.buttonBoxe {
  margin-left: -45px !important;
  text-align: left;
  padding: 5.5rem 0 0 0;
  text-align: center;
  width: 65%;
}
.buttonBoxs span {
  display: inline-block;
}
.buttonBoxe span {
  display: inline-block;
}
.footprint .section_network p {
  max-width: 500px;
}
.footprint .inner {
  height: 52%;
  width: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
}
/* #footerShow{
} */
.footprint .inner .imgbg {
  /* max-width: 100% !important;
  padding: 0 !important;
  background: url("../assets/homePage/home/footerprint_bg1.png") !important;
  background-size: 100% 100% !important;
  background-repeat: no-repeat !important;
  background-position: 0 0 !important;
  padding-top: 0;
  position: relative; */
  width: 100%;
  height: 100%;
}
.footprint .colInner {
  width: 40%;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  margin: 145px 0 0 0;
  color: black;
  z-index: 1;
}

.footerimg {
  animation: footan 6s forwards;
  -webkit-animation: footan 6s forwards;
}
.footertext {
  animation: textcolor 4s forwards;
  -webkit-animation: textcolor 4s forwards;
}
.footerbtn {
  /* display: inline-block; */
  animation: textcolor 4s forwards;
  -webkit-animation: textcolor 4s forwards;
  z-index: 4;
}
.footertitle {
  animation: title 4s forwards;
  -webkit-animation: title 4s forwards;
}
.footprint .colInner p {
  max-width: 400px;
  margin-bottom: 35px;
}
.footprint .colInner h1 {
  margin-bottom: 85px;
  margin-top: 0px;
}
.footprint {
  padding: 0 !important;
}
.footprint .inner img {
  /* width: 100%; */
  height: 100%;
  bottom: 0;
  right: 0;
}
.footmbimg {
  width: 100%;
  /* height:100%; */
}
@keyframes footan {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-webkit-keyframes footan {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes textcolor {
  0% {
    opacity: 0;
  }
  60% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-webkit-keyframes textcolor /*Safari and Chrome*/ {
  0% {
    opacity: 0;
  }
  60% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes title {
  0% {
    opacity: 0;
  }
  60% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-webkit-keyframes title /*Safari and Chrome*/ {
  0% {
    opacity: 0;
  }
  60% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.futureList {
  margin: 0 -10px;
}
.futureSliderItem {
  width: 20%;
  float: left;
}
.futureSliderItem:nth-child(odd) {
  margin-top: 40px;
}
.futureList .fadeInDown {
  -webkit-animation-name: fadeInDown;
  animation-name: fadeInDown;
}
.futureList .animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
.animated1 {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
.animated2 {
  -webkit-animation-duration: 2s;
  animation-duration: 2s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
.animated25 {
  -webkit-animation-duration: 2.5s;
  animation-duration: 2.5s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
.animated3 {
  -webkit-animation-duration: 3s;
  animation-duration: 3s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
.animated4 {
  -webkit-animation-duration: 4s;
  animation-duration: 4s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
.animated5 {
  -webkit-animation-duration: 5s;
  animation-duration: 5s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
.futureItem {
  color: #fff;
}
.futureItem .itemContent {
  position: absolute;
  top: 5%;
  left: 5%;
  right: 5%;
  bottom: 5%;
  display: flex;
  align-items: center;
  text-align: center;
}
.futureItem .itemContentInner {
  position: absolute;
  width: 100%;
  text-align: center;
  top: 50%;
  transform: translate(0, -50%);
}
.futureItem .icon {
  font-size: 60px;
  width: 60px;
  height: 60px;
  /* margin-bottom: 20px; */
  margin: 0 auto;
  padding-bottom: 20px;
}
#commpanyShow .futureSliderItem:nth-child(1) .futureItem .icon {
  width: 100px;
  height: 100px;
}
.futureList .icon img.onlyTD {
  display: inline-block !important;
}
.futureItem p {
  text-shadow: 0 2px 0 rgb(0 0 0 / 50%), 0 0 35px rgb(0 0 0 / 92%);
  margin: 0 0 10px;
}
.futureItem .itemContentInner p {
  font-size: 15px;
}
.futureItem .itemContentInner .messageMb {
  width: 50px;
}
.messageMob .itemContentInner .messageMb {
  width: 50px !important;
  margin: 10px auto;
  display: block;
}
.messageMob .swiper-container {
  /* margin: 0 20px; */
  text-align: center;
}
.futureItem .heading2 {
  font-size: 44px !important;
  line-height: 4rem;
}
.heading3 {
  font-size: 24px !important;
  margin: 0px;
}
.heading4 {
  font-size: 12px !important;
  margin: 0px;
}
.heading5 {
  font-size: 12px !important;
  margin: 0px;
}
.messageMob .swiper-slide {
  height: 200px;
}
.messageMob img {
  /* width: 100%; */
  height: 100%;
}
.discoverMob img {
  width: 100%;
  /* height: 100%; */
  object-fit: cover;
}
.messageMob .swiper-four .swiper-wrapper .swiper-slide {
  width: 100%;
}
.sliderun {
  animation: fadeInUpDistribution 1s forwards;
  -webkit-animation: fadeInUpDistribution 1s forwards;
}
.mobileSty .el-carousel--horizontal {
  overflow-y: hidden;
}
@keyframes messageMove {
  0% {
    -webkit-transform: translateY(70%);
  }
  100% {
    -webkit-transform: translateY(0%);
  }
}
@-webkit-keyframes messageMove /*Safari and Chrome*/ {
  0% {
    -webkit-transform: translateY(70%);
  }
  100% {
    -webkit-transform: translateY(0%);
  }
}
.pichidden {
  animation: picHidden 1s forwards;
  -webkit-animation: picHidden 1s forwards; /*Safari and Chrome*/
}
.pichiddens {
  animation: picHiddens 1s forwards;
  -webkit-animation: picHiddens 1s forwards; /*Safari and Chrome*/
}
@keyframes picHidden {
  0% {
    height: 491px;
  }
  100% {
    height: 300px;
  }
}
@-webkit-keyframes picHidden {
  0% {
    height: 491px;
  }
  100% {
    height: 300px;
  }
}
@keyframes picHiddens {
  0% {
    height: 300px;
  }
  100% {
    height: 491px;
  }
}
@-webkit-keyframes picHiddens {
  0% {
    height: 300px;
  }
  100% {
    height: 491px;
  }
}
.swiper-pagination-bullet-active {
  opacity: 1;
  background: #007aff !important;
}
.swiper-pagination1,
.swiper-pagination2 {
  width: 100%;
  text-align: center;
  margin-top: 12px;
  z-index: 1;
}
.swiper-pagination1 {
  position: absolute;
}
.discoverMob .swiper-pagination1 span.swiper-pagination-bullet,
.messageMob .swiper-pagination2 span.swiper-pagination-bullet {
  width: 10px !important;
  height: 10px !important;
  margin: 5px !important;
  display: inline-block;
  border-radius: 100%;
  background: #cbcbcb;
  opacity: 0.9;
}
</style>
<style lang="less" scoped>
.el-loading-mask {
  background-color: rgba(255, 255, 255, 1) !important;
}
.inner {
  margin: 0 auto;
  box-sizing: border-box;
  padding: 0;
}
.section_business .leftContent {
  width: 100%;
  padding-right: 300px !important;
}
.heading-underline:after {
  display: none !important;
}
.companyInner .title p {
  font-size: 50px;
  line-height: 50px;
}
.textnowrap {
  overflow: hidden;
  // white-space: nowrap;
  // text-overflow: ellipsis;
  // -o-text-overflow: ellipsis;
}
.bannerImg {
  position: relative;
  top: 0px;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 0;
  height: 100vh;
}
.itemBg {
  position: relative;
}
#commpanyShow {
  max-width: 1220px;
  margin: 0 auto;
}
.dealership {
  max-width: 1220px;
  margin: 0 auto;
}
.namedowns {
  position: absolute;
  bottom: 1rem;
  left: calc(50% - 45px);
  z-index: 99;
  color: white;
  cursor: pointer;
  font-size: 13px;
  font-weight: 700;
  text-align: center;
  text-shadow: 0 2px 0 #222121, 0 0 35px #222121;
  opacity: 1;
  transition: opacity 0.3s;
  width: 99px;
  margin: 0 auto;
  display: inline-block;
}
.countItem {
  height: 200px;
}
.countItempc {
  width: 20% !important;
  .iconBox {
    width: 50px;
    height: 50px;
  }
  .count {
    font-size: 40px;
  }
}
// .section {
//   background: #fff;
// }
.section .colInner {
  // position: relative;
  // height: 550px;
  // top: 50px;
}
.section .colInner .footermbimg {
  height: 100px;
  background-image: url(../assets/page-bg.jpg);
  background-repeat: no-repeat;
  background-position: bottom center;
  background-size: contain;
  margin: 0px;
  padding-top: 0px !important;
}
.section .colInner .footermbbtn {
  margin-top: 20px;
}
.section .inner strong {
  line-height: 52px;
}
.footmbmask {
  position: absolute;
  left: 0;
  height: 80%;
  top: -220px;
  width: 100% !important;
}
.distribution_footer {
  text-align: center;
  max-width: 860px;
  margin: 0 auto;
  padding-bottom: 20px;
}
.countListInnerflex {
  display: flex;
  justify-content: center;
}
.heading-underline.newTitle:after{
  display: block !important;
}
.newTitle {
  margin: 0;
  padding: 100px 20px 36px;
}
.section_discover .discover-mobile .discoverSlider .slide {
  padding: 0 15px 0 5px;
}
.mobile .innerPage {
  margin-bottom: -9px;
}
.mobile .section_services .serviceInner .serviceTextM {
  left: -11px;
}
.mobile .section_services .serviceItem .bgImg {
  left: -11px;
}
.mobile .inner {
  padding: 0px 20px;
}
.desktop .section_news_homepage {
  top: -7px;
  padding-top: 0;
  padding-bottom: 195px;
  // max-width: 1220px;
  margin: 0 auto;
}
.desktop .section_network .inner {
  padding-bottom: 12px;
}
.discover_title {
  text-align: center;
  font-size: 32px;
}
.innerpc {
  // padding-top: 56px;
  // padding-bottom: 120px !important;
}

.networkCol-1 {
  width: 100%;
  padding: 30px 0;
}
// .section_network {
//   background-image: url(../assets/page-bg.jpg);
//   background-repeat: no-repeat;
//   background-position: bottom center;
//   background-size: contain;
//   margin: 0px;
//   padding-top: 0px !important;
// }
.section_networkm {
  padding-top: 0px;
}
.section_partners .mask img {
  position: absolute;
  top: 0;
  z-index: 25;
  opacity: 0;
}
// .section_discover .discover-mobile .discoverSlider .slide {
//   padding: 0 0px;
// }
.footertitle.heading-underline:after {
  display: none !important;
}
.desktop .section_news_homepage .newsListInner {
  // position: absolute;
  // bottom: 0px;
  // left: 0;
  // right: 0;
  // z-index: 1;
  // padding-top: 100px;
}
.mobile .section_news_homepage .newsListInner {
  position: relative;
  top: -50px;
}
.businessStyle {
  display: flex;
  justify-content: center;
  align-items: center;
}
.logoOne:nth-child(1) {
  margin-left: 13%;
}
// .brandList .brandItemSix {
//   width: 26%;
//   margin-left: 6%;
// }

// .brandList .brandItemOther {
//   // width: 20%;
//   // margin-left: 4%;
// }
.brandList {
  max-width: 100%;
}
.brandFive {
  max-width: 100% !important;
  text-align: center;
  z-index: 99;
}
.brandList .brandItem {
  // padding: 30px 30px 30px 0;
  text-align: center;
}
.desktopSty {
  display: block;
  // padding-left: 15px;
}
.mobileSty {
  display: none;
}
.rezPic1,
.rezPic2,
.rezPic3,
.rezPic4 {
  display: none;
}
@media screen and (min-width: 780px) {
  .section .inner strong {
    font-size: 48px;
  }
  .brandList .brandItem {
    height: auto;
  }
  .section_partners .description {
    padding: 1rem 0;
  }
}
@media screen and (min-width: 780px) and (max-width: 1000px) {
  .buttonBoxs {
    padding: 0;
  }
  .buttonBoxe {
    padding: 0;
  }
  .section_partners .description {
    padding: 0.3rem 0;
  }
  .section_partners .brandList {
    margin: 0;
  }
  .section_partners .title {
    margin: 20px 0 8px 0 !important;
  }
  .section_partners .titlee {
    margin: 4px 0 8px 0 !important;
  }
}
@media screen and (min-width: 3100px) and (max-width: 3300px) {
  .buttonBoxe {
    padding: 100px 0 30px 0;
  }
  .section_partners .titlee {
    margin: 25px 0 25px 0 !important;
  }
}
@media screen and (min-width: 1910px) and (max-width: 1930px) {
  .buttonBoxe {
    padding: 100px 0 30px 0;
  }
  .section_partners .titlee {
    margin: 25px 0 25px 0 !important;
  }
}
@media screen and (min-width: 1410px) and (max-width: 1600px) {
  .buttonBoxe {
    padding: 100px 0 30px 0;
  }
  .section_partners .titlee {
    margin: 25px 0 25px 0 !important;
  }
}
@media screen and (min-width: 1367px) and (max-width: 1410px) {
  .buttonBoxe {
    padding: 30px 0;
  }
  .section_partners .titlee {
    margin: 25px 0 25px 0 !important;
  }
}
@media screen and (min-width: 1200px) and (max-width: 1366px) {
  .buttonBoxs {
    padding: 36px 0;
  }
  .buttonBoxe {
    padding: 30px 0;
  }
  .section_partners .titlee {
    margin: 25px 0 25px 0 !important;
  }
}
@media screen and (min-width: 1000px) and (max-width: 1200px) {
  .buttonBoxs {
    padding: 1.5rem 0;
  }
  .buttonBoxe {
    padding: 1.5rem 0;
  }
  .section_partners .titlee {
    margin: 25px 0 25px 0 !important;
  }
}
@media screen and (min-width: 780px) and (max-width: 1220px) {
.newsinner_width{
  width: 100% !important;
  margin: 0 auto;
}
}

@media screen and (max-width: 780px) {
  .journal-content-article {
    height: auto !important;
  }
  .desktopSty {
    display: none;
  }
  .mobileSty {
    display: block;
  }
  .mobile .heading1 {
    font-size: 32px;
  }
  .section_partners .title {
    margin-bottom: 30px;
  }
  .heading-underline:after {
    display: none;
  }
  // .section_partners .buttonBox{
  //   padding-bottom: 0px;
  // }
  .brandList .brandItem {
    padding: 22px;
  }
  .companyInner .title p {
    font-size: 32px;
    line-height: 32px;
  }
  .itemContent {
    position: absolute;
    left: 0;
    top: 28px;
    color: white;
    width: 100%;
    height: 65%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .brandList .brandItem {
    text-align: center;
  }
  .companyInner .heading1 {
    font-size: 32px;
  }
  .endDates {
    font-size: 12px;
  }
  .companyInner {
    margin: 0;
  }
  .location {
    // position: absolute;
    text-align: center;
    width: 100%;
    // top: -180px;
    z-index: 1;
  }
  .section_network p {
    padding: 0 10px;
  }
  .section .colInner {
    // position: relative;
    // height: 430px;
    // top: 150px;
  }
  .footmbimg {
    width: 100%;
    margin-top: -30px;
    /* height:100%; */
  }
  .track {
    // position: absolute;
    z-index: 1;
    // top: -116px;
  }
  .section_discover {
    margin-top: 0px;
  }
  // .journal-content-article{
  //   height: 1000px;
  // }
}
.bannerSty {
  overflow: hidden;
}
.newsInner {
  background-image: url(../assets/homePage/home/news_bg.jpg);
}
.section_news_v2 .newsListInner .newsItemInner .newsItem .oneCenturyBg:before {
  background-image: url("../assets/newCenter/yiJiBaiQiang/CenturyTop.png");
}
.section_news_v2 .newsListInner .newsItemInner .newsItem .heNanBg:before {
  background-image: url("../assets/newCenter/heNan/rushHenan.jpg");
}
.section_news_v2 .newsListInner .newsItemInner .newsItem .ruralBg:before {
  background-image: url("../assets/newCenter/xiangCun/rural.png");
}
.section_news_v2 .newsItem .news .description {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  line-clamp: 3;
  box-orient: vertical;
  width: 100%;
  height: 63px;
  overflow: hidden;
  font-size: 14px;
  line-height: 22px;
  text-overflow: ellipsis;
}
.descriptionpc {
  margin-top: 0;
}
.desktop .section_partners .description {
  max-width: 800px !important;
}
.newsItem .description p {
  font-size: 14px;
  line-height: 22px;
  margin: 0;
}
.newsinner_width{
  width: 1220px;
  margin: 0 auto;
}
// 新闻 ↑
.finance {
  background-image: url(../assets/homePage/brandPartner/Pfinance.jpg);
}
.afterSale {
  background-image: url(../assets/homePage/brandPartner/PafterSale.jpg);
}
.usedCar {
  background-image: url(../assets/homePage/brandPartner/PusedCar.jpg);
}
.newCar {
  background-image: url(../assets/homePage/brandPartner/Pnewcar.jpg);
}
.Pluxury {
  background-image: url(../assets/homePage/brandPartner/Pluxury.jpg);
}
.parallax {
  background-image: url(../assets/homePage/home/PbeatBack.jpg);
}
.static {
  background-image: url(../assets/homePage/home/MbeatBack.png);
}
.swiper-container,
.swiper-containerPad,
.swiper-containerMobile {
  height: 100%;
  width: 100%;
  .swiper-wrapper {
    .swiper-slide {
      width: 100%;
      // height: 100%;
      // text-align: center;
      // line-height: 100%;
    }
  }
}
.section_discover {
  margin-top: 40px;
}
</style>
